"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWrapper = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var clsx_1 = __importDefault(require("clsx"));
var React = __importStar(require("react"));
require("./iconWrapper.css");
var IconWrapper = /** @class */ (function (_super) {
    __extends(IconWrapper, _super);
    function IconWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconWrapper.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)("icon-wrapper icon-wrapper-".concat(this.props.backGroundColor)), css: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                    width: ", "rem;\n                    height: ", "rem;\n                    border-radius: 100%;\n                    padding: ", "rem;\n                    border: ", ";\n                    margin: ", ";\n                "], ["\n                    width: ", "rem;\n                    height: ", "rem;\n                    border-radius: 100%;\n                    padding: ", "rem;\n                    border: ", ";\n                    margin: ", ";\n                "])), this.props.width, this.props.width, this.props.padding, this.props.border, this.props.margin) }, { children: this.props.children })));
    };
    IconWrapper.defaultProps = {
        shape: 'circle',
        backGroundColor: 'white',
        border: 'none',
        margin: '0',
        padding: 0.3,
    };
    return IconWrapper;
}(React.PureComponent));
exports.IconWrapper = IconWrapper;
var templateObject_1;
//# sourceMappingURL=IconWrapper.js.map